module.exports = __webpack_public_path__ + "static/media/hengshan_package.80034cf2.webp";